var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 15.4433L14.0767 11.9595C15.1375 10.3717 15.5697 8.44602 15.2893 6.55715C15.0089 4.66828 14.0359 2.95125 12.5596 1.74003C11.0833 0.528815 9.20929 -0.089976 7.30203 0.00402155C5.39478 0.0980192 3.59067 0.898084 2.24064 2.24859C0.890612 3.5991 0.0911842 5.40349 -0.00213913 7.31078C-0.0954624 9.21806 0.523991 11.0919 1.73573 12.5677C2.94747 14.0436 4.66485 15.016 6.55381 15.2957C8.44278 15.5755 10.3683 15.1426 11.9558 14.0813L15.4395 17.5643C15.7232 17.841 16.1037 17.9958 16.5 17.9958C16.8963 17.9958 17.2768 17.841 17.5605 17.5643C17.8417 17.283 17.9997 16.9015 17.9997 16.5038C17.9997 16.106 17.8417 15.7246 17.5605 15.4433ZM7.6875 2.25377C8.76294 2.25377 9.81422 2.57267 10.7084 3.17015C11.6026 3.76763 12.2995 4.61685 12.7111 5.61043C13.1226 6.604 13.2303 7.6973 13.0205 8.75207C12.8107 9.80684 12.2928 10.7757 11.5324 11.5362C10.7719 12.2966 9.80308 12.8145 8.7483 13.0243C7.69353 13.2341 6.60023 13.1264 5.60666 12.7149C4.61309 12.3033 3.76387 11.6064 3.16639 10.7122C2.56891 9.81799 2.25 8.7667 2.25 7.69127C2.25159 6.24964 2.82498 4.86751 3.84436 3.84813C4.86375 2.82874 6.24587 2.25536 7.6875 2.25377Z",
    fill: "#CCD6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.583e09226163b41d35d78caf482d5a74.svg";
export { ForwardRef as ReactComponent };